import { render, staticRenderFns } from "./NavChildItem.vue?vue&type=template&id=19ae5634&scoped=true&"
import script from "./NavChildItem.vue?vue&type=script&lang=js&"
export * from "./NavChildItem.vue?vue&type=script&lang=js&"
import style0 from "./NavChildItem.vue?vue&type=style&index=0&id=19ae5634&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae5634",
  null
  
)

export default component.exports